import { configureStore } from '@reduxjs/toolkit';
import modalsReducer from './modalsSlice'

import CustomViewReducer from './CustomViewSlice';




import AdminPageReducer from '../features/AdminPage/AdminPageSlice';
import schoolinfoManagerReducer from '../features/AdminPage/SchoolInfoManager/SchoolInfoManagerSlice';
import userManagerReducer from '../features/AdminPage/userManager/UserManagerSlice';


import homePageReducer from "../features/HomePage/HomePageSlice";
import teacherManagerReducer from '../features/HomePage/teacherManager/teacherManagerSlice';
import playerModalReducer from '../features/PlayerModal/PlayerModalSlice';

import CaiwuPageReducer from '../features/CaiwuPage/CaiwuPageSlice';
import schoolAdminPageReducer from '../features/SchoolAdmin/SchoolAdminSlice';

export const store = configureStore({
  reducer: {
    modals:modalsReducer,
    // 产品运营
    CustomView:CustomViewReducer,
  //   大管理员登录的reducer
    AdminPage:AdminPageReducer,
    schoolInfoManager:schoolinfoManagerReducer,
    userManager:userManagerReducer,

    //学校账号， 学校成员，普通成员登录的reducer
    homePage:homePageReducer,
    teacherManager:teacherManagerReducer,
    playerModal:playerModalReducer,
    caiwuPage:CaiwuPageReducer,
    schoolAdminPage:schoolAdminPageReducer,
  },
});
